module.exports = __webpack_public_path__ + "static/category-bag-3db22089392ad72a004abd167c63254e.jpg";